import React from 'react';
import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';

const DataGrid = (props) => {
    return (
        <MuiDataGrid
            {...props} // Pass all props from parent to the MUI DataGrid
        />
    );
};

export default DataGrid;